import type { ClientTheme } from "@/app/lib/themes"

interface PageHeaderProps {
  title: string
  subtitle: string
  theme: ClientTheme
  /** The page's nav icon, rendered in a tinted tile beside the title. */
  icon?: React.ReactNode
}

export function PageHeader({ title, subtitle, theme, icon }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center">
        {icon && (
          <div
            className="flex items-center justify-center flex-shrink-0 rounded-lg"
            style={{
              width: "34px",
              height: "34px",
              marginRight: "12px",
              backgroundColor: theme.sidebarActiveBg,
              color: theme.brandAccent,
            }}
          >
            {icon}
          </div>
        )}
        <div>
          <h1
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "21px",
              fontWeight: 600,
              color: theme.textPrimary,
              lineHeight: 1.2,
            }}
          >
            {title}
          </h1>
          <p
            style={{
              fontFamily: "var(--font-ui)",
              fontSize: "13px",
              color: theme.textMuted,
              marginTop: "3px",
            }}
          >
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  )
}
